import { Component } from "@angular/core";

@Component({
  selector: "autoCompleteBox",
  templateUrl: "autoCompleteBox.component.html",
  styleUrls: ["autoCompleteBox.component.css"],
})
export class AutoCompleteBoxComponent {
  autoCompleteList: any;

  cancel: () => void;
  clickItem: ($event: any, item: any) => void;


  printScore(item) {
    const conf =  Math.round(item.word.confidence*100)
    if (!item.score) return conf
    const score = Math.round(item.score*100)
    return score 
  }
}
